import Bowser from 'bowser';

import window from 'core/includes/window';

// @see https://github.com/bowser-js/bowser/blob/8c489bd98b0128ce57edb4cbaf2a398170f2c466/src/constants.js
// For references of Bowser's constants

export default window?.navigator?.userAgent ? Bowser.getParser(window.navigator.userAgent) : null;
